// removed by extract-text-webpack-plugin
module.exports = {"background":"_78mVzriSagobuJSNK4dmx","background-placeholder":"_3OUUGPCxr0n2Wp8l515O_C","backgroundPlaceholder":"_3OUUGPCxr0n2Wp8l515O_C"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/video/backgroundVideo.css
// module id = 327
// module chunks = 0